export const isAdminUser = (user) => (
  user?.role === "admin" || user?.is_admin === true || user?.isAdmin === true
);
